// removed by extract-text-webpack-plugin
module.exports = {"exception":"app-QtP4oxat","imgBlock":"app-3AzrKf1S","imgEle":"app-2f-LfqOO","content":"app-3sbBBfQv","desc":"app-1tRUUBHD","actions":"app-R_t4nnMs"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-components/exception/index.less
// module id = 865
// module chunks = 0